export const configs = {
  LANGUAGES: ['IT', 'GB'],
  supportEmail: "support@planetinfofun.it",
  socialIcons: [
    { id: 'si1', socialName: 'facebook', link: '' },
    { id: 'si2', socialName: 'instagram', link: '' },
    { id: 'si3', socialName: 'telegram', link: '' },
    { id: 'si4', socialName: 'youtube', link: '' },
  ],
  websiteName: 'PlanetslotFun',
  websiteNameDomainStarting: 'planetslot',
  websiteNameDomainEnding: 'fun',
  showGuideBannerImage: false,
  showGuideInfoImage: false,
  navigation: [
    { path: '/tipster', name: 'tipster' },
  ]
};